<template>
  <div>
    <q-breadcrumbs>
      <q-breadcrumbs-el label="Home" icon="home" @click="$router.push('/home')"></q-breadcrumbs-el>
      <q-breadcrumbs-el :label="$t('breadcrumbs.info.pageinfo')" icon="supervisor_account"></q-breadcrumbs-el>
    </q-breadcrumbs>

    <div class="row">
      <div class="col-8 offset-2">
        <q-card class="bg-white">
          <q-card-section>
            <h5>Groeidocument</h5>
            <p>
              Ieder kind is anders. Voor veel kinderen zijn onze scholen en ons onderwijs een prima basis om zich te
              ontwikkelen, maar niet voor allemaal. Een aantal kinderen hebben daar een extra steuntje in de rug voor
              nodig.
            </p>
            <p>
              Met het Groeidocument ben je als school, leerkracht, begeleider, ouder of samenwerkingsverband goed in
              staat om
              dat extra steuntje te bieden. Op maat. Want ook de ondersteuning die nodig is, is voor ieder kind weer
              anders. Het
              Groeidocument biedt inzicht in wat goed is voor deze leerling, ondersteunt samenwerking tussen betrokken
              partijen
              en helpt bij de keuze van de juiste handeling. Het Groeidocument ondersteunt dit proces op maat.
            </p>
            <p>
              Voor het bekijken van instructiefilmpjes, klik op de knop hieronder: <br><br>
              <q-btn @click="viewVideo()" class="no-shadow" color="primary" label="Bekijk instructiefilmpjes"></q-btn>
              <!--<a href="https://groeidocument.nl/instructiegd2-0/"></a>-->
            </p>
          </q-card-section>
        </q-card>
      </div>
    </div>

  </div>
</template>
<script>
  import axios from 'axios'

  import { QBreadcrumbs, QBreadcrumbsEl, QBtn, QCard, QCardSection } from 'quasar'

  import packageJson from '../../package'

  export default {
    name: 'start_scan',
    data () {
      return {
        productName: packageJson.productName,
        version: packageJson.version,
        liveVersion: '0.0.0',
        componentsVersion: packageJson.dependencies['@parantion/components'],
        date: __DATE
      }
    },
    components: {
      QBtn,
      QCard,
      QBreadcrumbs,
      QBreadcrumbsEl,
      QCardSection
    },
    created () {
      axios.get(location.href).then(result => {
        const versions = result.data.match(/\d*\.\d*\.\d*/)
        if (versions.length > 0) {
          console.log('versions', versions)
          this.liveVersion = versions[0]
        }
      })
    },
    methods: {
      viewVideo () {
        window.open('https://groeidocument.nl/instructiegd2-0/', '_blank')
      }
    }
  }
</script>

<style lang="stylus">

  @import '~variables';

  $gridFabBaseColor = lightness($tertiary, 35%);
  $buttonSize = 3.5vh;

  .q-data-table
    .q-btn-round {
      .q-fab-icon {
        font-size: 24px;
      }

      .q-btn-small .q-icon {
        font-size: 19px;
      }
    }

    .actionColumn {
      text-align: right
      overflow: visible !important

      .q-btn {
        height $buttonSize
        min-height 30px
        width: $buttonSize
        min-width 30px
      }
    }

    .statusColumn {
      span {
        text-align: center
        width: 51px;
      }
    }

    .my-label {
      padding: 6px 8px 6px 8px !important
      border-radius: 5px !important
      display: inline-block !important
    }

    .q-btn-round {
      -webkit-border-radius: 0 !important
      -moz-border-radius: 0 !important
      border-radius: 0 !important
    }

    .fab-buttons {
      .q-btn-inner {
        //height $buttonSize
        //min-height: 30px;
        //width: $buttonSize;
        //min-width: 30px;
        overflow: visible !important;
      }

      .disabled, [disabled] {
        opacity: 0.3 !important;
      }

      .q-fab-left {
        right: 100%;
      }

      .q-btn-round.q-btn-standard {
        height: $buttonSize;
        min-height: 30px;
        width: $buttonSize;
        min-width: 30px;
        overflow: visible !important;
      }

      .q-fab-icon {
        height: 100%;
        top: calc(50% - 12px);
      }

      .q-fab-active-icon {
        top: calc(50% - 13px);
      }

      .q-fab-actions {
        background-color: $gridFabBaseColor;
        border-right: 1px solid $gridFabBaseColor;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
        padding: 5px;

        button {
          background: white;
          height: 100%;
          min-height: 24px
          width: 100%;
          min-width: 24px
        }
      }
    }

  .lock-icon {
    font-size: 200%
  }

  .warning-icon {
    font-size: 200%
    color: $warning
  }
</style>
